<div class="link-centered">
    <a *ngIf="showLink()" href="javascript:void(0)" (click)="onClick()">
        open {{ linkLabel}}
    </a>
    <span *ngIf="!showLink()">{{ linkLabel}} not received</span>
</div>